import VLogin from './src/VLogin.vue';

VLogin.install = function (app) {
  app.component(VLogin.name, VLogin)
}

export default VLogin



//////////////////
// WEBPACK FOOTER
// ./packages/vlogin/index.js
// module id = null
// module chunks = 